/* global I18n */

import React from "react"
import alexandra_testimonial_img from
  "images/success_stories/alexandra_profile.webp"
import FaIcon from "../fa_icon"

function PreviewCTA({on_close}) {
  return (
    <div className="learn-more-card learn-more-card--sample-quiz">
      <FaIcon name="fa-close" onClick={on_close} className="close"/>
      <div className="cta-content">
        <p className="title">
          {I18n.t("js.embedded_quiz.preview_summary.title")}
        </p>
        <p>{I18n.t("js.embedded_quiz.preview_summary.copy")}</p>
      </div>
      <div className="text-center">
        <a
          className="btn btn-primary"
          href={window.gon.pricing_path}
          data-track="pricing page clicked"
          data-track-element="training summary">
          {I18n.t("js.embedded_quiz.preview_summary.cta")}
        </a>
      </div>
      <div className="testimonial-section">
        <img
          className="profile-picture"
          alt="Alexandra Orfanides"
          src={alexandra_testimonial_img}
        />
        <blockquote>
          {I18n.t("js.embedded_quiz.preview_summary.quote")}
        </blockquote>
        <span className="student-info">
          Alexandra Orfanides, The University College of Ostheopathy
        </span>
      </div>
    </div>
  )
}

export default PreviewCTA
